import React from "react";
import Svg, { Path, Circle, G } from "react-native-svg";
import AppTheme from "../../../AppTheme";

export default function RadioIcon({ size }) {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G>
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 16C3.61905 16 0 12.381 0 8C0 3.61905 3.6129 0 7.99386 0C12.3748 0 16 3.61905 16 8C16 12.381 12.381 16 8 16ZM8.00013 14.8571C11.7974 14.8571 14.8634 11.7972 14.8573 8C14.8511 4.20276 11.7912 1.14286 7.99399 1.14286C4.19061 1.14286 1.14913 4.20276 1.14913 8C1.14913 11.7972 4.19675 14.8571 8.00013 14.8571Z"
          fill={AppTheme.DEFAULT_COLOR}
        />
        <Circle cx="8" cy="8" r="5" fill={AppTheme.DEFAULT_COLOR} />
      </G>
    </Svg>
  );
}
